import React from 'react';
import Select from 'react-select'
import clsx from 'clsx';
import { Tooltip, Typography, withStyles } from "@material-ui/core";
import HelpIcon from '@material-ui/icons/Help';
// https://react-select.com/styles

const styles = theme => ({
    selectWrapper: {
        marginBottom: 20,
    },
    labelWrapper: {
        width: '100%',
        display: 'flex',
    },
    label: {
        color: '#878787',
        flex: 1,
        fontSize: 12,
    },
    select: {
        flex: 1,
    },
    padding: {
        padding: '0px',
        '& path': {
            fill: '#6EA0D7'
        }
    },
    option: {
        fontSize: '10px'
    },
    note: {
        color: '#A9A9A9',
        fontSize: '10px',
        textAlign: 'left'
    },
    helpIcon: {
        color: "#0000008a",
        cursor: 'pointer',
        marginLeft: 8,
    },
    helperIconSelectWrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%'
    }
})

/**
 * @template P
 * @param {P & {
 *  options: { label: string; value: number|string }
 * }} props
 */
const ReactSelect = (props) => {

    const { onChange, labelText, labelColor, labelClass, classes, selectWrapperClass, labelWrapperClass, customStyles = false, selectClass, target, extraOnChange, error = false, note = null, helpIconText = null, ...other } = props;
    let AuxStyle = error ?
        {
            ...customStyles,
            control: base => ({
                ...base,
                borderColor: 'red'
            }),
        } : customStyles
    return (
        <div className={clsx(classes.selectWrapper, selectWrapperClass)}>
            {labelText ?
                <div className={clsx(classes.labelWrapper, labelWrapperClass)}>
                    <Typography className={clsx(classes.label, labelClass)} color={labelColor}>{labelText}</Typography>
                </div>
                : ''}

            <div className={classes.helperIconSelectWrapper}>
                <Select
                    className={clsx(classes.select, selectClass)}
                    styles={AuxStyle}
                    onChange={(selectedValue) => {
                        onChange(target, selectedValue, extraOnChange)
                    }}
                    hideSelectedOptions={false}
                    menuPlacement="auto"
                    {...other}
                    theme={theme => ({
                        ...theme,
                        borderRadius: 3,
                        borderColor: error ? 'red' : '#E6EDF5',
                        colors: {
                            ...theme.colors,
                            primary: '#E6EDF5',
                        },
                    })}
                />

                {helpIconText && (
                    <Tooltip
                        title={
                            <>
                                {helpIconText}
                            </>
                        }
                        arrow
                    >
                        <HelpIcon
                            className={classes.helpIcon}
                            fontSize="small"
                        />
                    </Tooltip>
                )}
            </div>


            <span><small className={classes.note}>{note}</small></span>
        </div>
    );
}

export default withStyles(styles)(ReactSelect);
